import { StripeAuthConnectRequestSchema } from '@vy/api-definition';
import type { oz } from '@vy/utils';
import type { Control } from 'react-hook-form';

export const StripeRegisterFormSchema = StripeAuthConnectRequestSchema;

export type StripeRegisterFormValues = oz.infer<typeof StripeRegisterFormSchema>;
export type StripeRegisterControl = Control<StripeRegisterFormValues>;
